import React, { useState } from 'react';

function Gas_recharge_plan_card_holder() {
    return (
        <section className='Mobile_recharge_plan_card_holder DTH_recharge_plan_card_holder Gas_recharge_plan_card_holder '>
            <div className="plan_card_holder">
                <div className="info_holder">
                    <div className="row me-0 ms-0">
                        <div className="col-6">
                            <div className="text_holder">
                                <p>Customer Name:</p>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="text_holder">
                                <p>Pratiksha P.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info_holder">
                    <div className="row me-0 ms-0">
                        <div className="col-6">
                            <div className="text_holder">
                                <p>Distributor Contact:</p>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="text_holder">
                                <p>07132-457809</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info_holder">
                    <div className="row me-0 ms-0">
                        <div className="col-6">
                            <div className="text_holder">
                                <p>Distributor Name:</p>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="text_holder">
                                <p>Neeraj Gas Service</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info_holder">
                    <div className="row me-0 ms-0">
                        <div className="col-6">
                            <div className="text_holder">
                                <p>Consumer Address:</p>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="text_holder">
                                <p>2/74 Purva Building Police Line, Dharashiv</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="info_holder">
                    <div className="row me-0 ms-0">
                        <div className="col-6">
                            <div className="text_holder">
                                <p>Consumer Number:</p>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="text_holder">
                                <p>6138787</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Gas_recharge_plan_card_holder;
